
import { RouteType } from "./config";
import SectionPage2 from "../pages/section2/SectionPages";
import Planogramme from "../pages/planogramme/PlanogrammePage";
import AutoAwesomeMosaicIcon from '@mui/icons-material/AutoAwesomeMosaic';
import StorageIcon from '@mui/icons-material/Storage';
import AppError from "../pages/errors/AppError";

const appRoutes: RouteType[] = [
  {
    index: true,
    element: <Planogramme />,
    state: "home",
  },
  {
    path: '/planogramme',
    element: <Planogramme />,
    state: 'Planogramme',
    sidebarProps: {
      displayText: 'Planogramme',
      icon: <StorageIcon />
    },
  },
  {
    path: '/section',
    element: <SectionPage2 />,
    state: 'section',
    sidebarProps: {
      displayText: 'Sections',
      icon: <AutoAwesomeMosaicIcon />
    },
  },
  {
    path: '/error',
    element: <AppError />,
    state: 'error'
  }
];

export default appRoutes;
